import { useEffect, useState } from "react";
import TagManager from "./TagManager"
import { DefaultButton } from "./DefaultButton";
import { Col, Row } from "./Grid";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import { Modal } from "../utils/dialogUtlities";

const buildTags = (sort, fields) => fields ? Object.entries(fields).flatMap(([f, name]) => { if (sort.some(s => s === f)) { return [{ label: name + ' \u2193', value: f }] } else if (sort.some(s => s === '-' + f)) { return [{ label: name + ' \u2191', value: '-' + f }] } else { return [{ label: name + ' \u2193', value: f }, { label: name + ' \u2191', value: '-' + f }] } }) : [];

export const Sort = ({ sort, fields, placeholder, hideLabel = false, disabled = false, required = false, onChange }) => {
    const [values, setValues] = useState(buildTags(sort, fields));

    useEffect(() => {
        setValues(buildTags(sort, fields));
    }, [sort, fields]);

    return <TagManager placeholder={placeholder} disabled={disabled} tags={sort} values={values} labelField="label" valueField="value" required={required} hideLabel={hideLabel} onChange={onChange}></TagManager>
}

Sort.propTypes = {
    sort: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    hideLabel: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}

export const SortDialog = ({ sort: inputSort, fields, defaultOrder = [], placeholder, show = false, title, disabled = false, onClose }) => {
    const { t } = useTranslation();
    const [sort, setSort] = useState(inputSort);

    useEffect(() => setSort(inputSort), [inputSort]);

    return <Modal show={show}>
        <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Sort sort={sort} fields={fields} placeholder={placeholder} disabled={disabled} onChange={setSort}></Sort>
        </Modal.Body>
        <Modal.Footer>
            <Row className="w-100">
                <Col xs="auto" className="text-left">
                    <DefaultButton kind="clear" label={t('defaultSort')} onClick={() => setSort([...defaultOrder])}></DefaultButton>
                </Col>
                <Col className="text-right">
                    <DefaultButton kind="save" className="mx-1" onClick={() => onClose(sort)}></DefaultButton>
                    <DefaultButton kind="close" className="mx-1" onClick={() => onClose()}></DefaultButton>
                </Col>
            </Row>
        </Modal.Footer>
    </Modal>
}

SortDialog.propTypes = {
    sort: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    defaultOrder: PropTypes.array,
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onClose: PropTypes.func.isRequired
}